import React, { Component, Fragment } from 'react';
import axios from 'axios';

import './Home.css'

export default class Home extends Component {
  state = {
    characters:[],

  }
  componentDidMount() {
    axios.get(`/json/characters.json`)
      .then(res => {
        const characters = res.data;
        this.setState({ characters });
      })
  }
  click = (character) => {
    var _this = this;
    return (event) => {
      this.props.history.push("/browser/"+character+"/8001");
    }

  }
  render(){
    var {characters} = this.state;
    var _this = this;
    function _perChar(char,idx){
      var imgPath = char[1];
      if(['bs7','ja4','tes','yhe','ykz','zak'].includes(char[1])) return null;
      if(['kum','pan'].includes(char[1])) imgPath += "_"+Math.floor((Math.random() * 2)+1);
      return <a key={idx} onClick={_this.click(char[1])} ><img className="selectChar" src={"/img/CS_CH_PANEL_"+imgPath.toUpperCase()+".png"} /></a>

    }
    return <div className="container">
      <div className="row">
        <div className="four columns">
          <h1>T7Matrix by @dantarion</h1>
          <h4>What is this?</h4>
          <p>This is a resource aimed at showcasing move properties and data for characters in Tekken 7.
          The data is gathered in an automated manner. Currently the presented data is a bit robotic and hard to understand,
           but in time this will turn into a nice resource for competive players. Long live Tekken!</p>
          <h4>Whats new?</h4>
          <ul>
            <li>Alpha Release! Things are looking good!</li>
          </ul>
        </div>
        <div className="eight columns">
          <div className="u-cf"></div>
          <h4>Choose a Character</h4>
          <div>
            {characters.map(_perChar)}
          </div>
        </div>
      </div>
    </div>
  }
}
/*
<h4>1. Choose a Tool</h4>
<div className="toolList">
  <div><a>Moveset Browser</a></div>
  <div><a>Framedata Table</a></div>

</div>
*/



// WEBPACK FOOTER //
// ./src/Home.js